<button #downloadPdfButton (click)="downloadPdf()"  class="downloadButton"
*ngIf="canUploadSignerPdf || canUploadDesignerPdf || canUploadWatcherPdf || canUploadADMINPdf ">
 <i class="fas fa-question"></i>
</button>
